/**
 * External URLs used across the application (footer links, referral forms, home page, etc.).
 */

// ─── Optum home ───────────────────────────────────────────────────────────────
export const OPTUM_BH_HOME_URL = "https://www.optumbhcare.com/en-US";
export const CUSTOMER_SUPPORT_URL =
  "https://www.optum.com/en/customer-support/patient-support.html";

// ─── Legal / compliance ───────────────────────────────────────────────────────
export const PRIVACY_POLICY_URL = "https://www.optum.com/en/privacy-policy.html";
export const TERMS_OF_USE_URL = "https://www.optum.com/en/terms-of-use.html";
export const ACCESSIBILITY_URL = "https://www.optum.com/en/accessibility.html";
export const NOTICE_OF_PRIVACY_PRACTICES_URL =
  "https://www.optumbhcare.com/NoticeOfPrivacyPractices/en-US";
export const NO_SURPRISES_ACT_URL = "https://www.optumbhcare.com/NoSurprisesAct/en-US";
export const NON_DISCRIMINATION_NOTICE_URL =
  "https://www.optumbhcare.com/NoticeOfNondiscrimination/en-US";
export const NOTICE_OF_AVAILABILITY_URL = "https://optumbhcare.com/files/pdfs/Optum_NOA.pdf";
export const HEALTH_INFORMATION_EXCHANGE_URL =
  "https://www.optumbhcare.com/HealthInformationExchange/en-US";
export const ATHENA_PATIENT_LOGIN_URL = "https://pxppapp.px.athena.io/";

// ─── Referral webform ─────────────────────────────────────────────────────────
export const PROD_REFERRAL_WEBFORM_URL = "https://www.optumbhcare.com/referral-inquiry";
export const STAGE_REFERRAL_WEBFORM_URL = "https://stage.optumbhcare.com/referral-inquiry";
